import { Dispatch, SetStateAction } from 'react';

import SearchIcon from '../../assets/SearchIcon.svg';
import { CustomContainerSearch } from './styles';

interface ICustomSearch {
  searchedOption: string;
  setSearchedOption: Dispatch<SetStateAction<string>>;
  placeholder?: string;
}

const CustomSearch = ({
  searchedOption,
  setSearchedOption,
  placeholder,
}: ICustomSearch) => {
  return (
    <CustomContainerSearch>
      <input
        placeholder={placeholder || 'Pesquisar opção...'}
        value={searchedOption}
        onChange={text => setSearchedOption(text.target.value)}
      />
      <img src={SearchIcon} />
    </CustomContainerSearch>
  );
};

export { CustomSearch };
